import Autocomplete from '@mui/material/Autocomplete'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { ReactNode, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  InputErrorLabel,
  InputLabel,
  InputLabelBlock
} from 'components/common/TextInput'
import {
  AutocompleteTextFieldSXProps,
  SelectSXErrorProps,
  SelectSXProps
} from './Select.style'

interface Option {
  display: string | ReactNode
  value: string
  stringToDisplay: string
}

interface SelectWithSearchProps {
  fullSize?: boolean
  inputLabel: string
  fieldName: string
  errorMessage?: string
  placeholder: string
  options: Option[]
  disabled?: boolean
  noMargin?: boolean
}

export const SelectWithSearch = ({
  fullSize,
  inputLabel,
  fieldName,
  errorMessage,
  placeholder,
  options,
  disabled,
  noMargin
}: SelectWithSearchProps) => {
  const { setValue, register, watch } = useFormContext()
  const value: string = watch(fieldName)
  const [inputValue, setInputValue] = useState('')

  return (
    <InputLabelBlock fullSize={fullSize} noMargin={noMargin}>
      <InputLabel>{inputLabel}</InputLabel>
      <Autocomplete
        options={options}
        value={options.find((option) => option.value === value) ?? null}
        inputValue={inputValue}
        disabled={disabled}
        onChange={(_event, newValue: Option | null) => {
          setValue(fieldName, newValue?.value ?? '', {
            shouldValidate: true
          })
        }}
        onInputChange={(_event, newInputValue) => {
          setInputValue(newInputValue)
        }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option: Option) => option.stringToDisplay}
        renderOption={(props, option: Option) => (
          <MenuItem {...props}>{option.display}</MenuItem>
        )}
        sx={{
          ...SelectSXProps,
          ...(errorMessage && SelectSXErrorProps)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            disabled={disabled}
            sx={AutocompleteTextFieldSXProps}
          />
        )}
      />
      {errorMessage && <InputErrorLabel>{errorMessage}</InputErrorLabel>}
      <input hidden {...register(fieldName)}></input>
    </InputLabelBlock>
  )
}
